<template>
    <section class="max-w-4xl min-h-screen mx-auto px-6 py-16 mt-40">
        <h1 class="text-3xl font-bold text-primary mb-6">Mentions légales</h1>

        <div class="text-gray-700 space-y-4 text-sm leading-relaxed">
            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Éditeur du site</h2>
            <p>
                Le site <strong>My Profolia</strong> est édité par :<br />
                Paul Moinereau, entrepreneur individuel (EI)<br />
                SIRET : 851 815 761 00032<br />
                Adresse du siège social : 99 rue Jean Dausset, 84140 Avignon<br />
                Email : <a href="mailto:contact@myprofolia.com"
                    class="text-primary underline">contact@myprofolia.com</a><br />
                Directeur de la publication : Paul MOINEREAU
            </p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Hébergement</h2>
            <p>
                Le site est hébergé par :<br />
                OVH SAS – 2 rue Kellermann, 59100 Roubaix, France<br />
                Site web : <a href="https://www.ovh.com" target="_blank" rel="noopener"
                    class="text-primary underline">www.ovh.com</a>
            </p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Propriété intellectuelle</h2>
            <p>
                Le contenu de ce site (textes, images, code, design) est protégé par le droit d’auteur et la propriété
                intellectuelle. Toute reproduction, représentation, modification, publication, adaptation, totale ou
                partielle,
                sans autorisation écrite préalable de <strong>My Profolia</strong> est interdite.
            </p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Données personnelles</h2>
            <p>
                Aucune donnée personnelle n’est collectée sans votre consentement préalable. Vous pouvez nous contacter
                pour
                toute demande relative à vos données personnelles à l’adresse email :
                <a href="mailto:contact@myprofolia.com" class="text-primary underline">contact@myprofolia.com</a>.
                <br />
                Pour plus d’informations, veuillez consulter notre Politique de confidentialité.
            </p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Cookies</h2>
            <p>
                Ce site peut utiliser des cookies à des fins de mesure d’audience anonymes via Google Analytics. Une
                bannière de
                consentement vous informe à la première visite. Vous pouvez désactiver les cookies à tout moment dans
                les
                paramètres de votre navigateur.
            </p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Crédits</h2>
            <p>Design & développement : Paul Moinereau</p>
            <p>Icônes : FontAwesome – <a href="https://fontawesome.com" target="_blank" rel="noopener"
                    class="text-primary underline">fontawesome.com</a></p>
            <p>Typographies : Google Fonts – Poppins & Caveat</p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Responsabilité</h2>
            <p>
                My Profolia met tout en œuvre pour assurer l’exactitude et la mise à jour des informations diffusées sur
                le
                site. Cependant, My Profolia ne saurait être tenu responsable des erreurs, d’une absence de
                disponibilité des
                informations ou de la présence de virus sur son site.<br />
                La responsabilité de My Profolia ne peut être engagée en cas de dommages directs ou indirects liés à
                l’utilisation du site.
            </p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Liens hypertextes</h2>
            <p>
                Le site peut contenir des liens vers d’autres sites internet. My Profolia n’exerce aucun contrôle sur
                ces sites
                et décline toute responsabilité quant à leur contenu ou leurs politiques de confidentialité.
            </p>

            <h2 class="text-xl font-semibold mt-8 mb-2 text-primary">Droit applicable</h2>
            <p>
                Les présentes mentions légales sont soumises au droit français. En cas de litige, compétence exclusive
                est
                attribuée aux tribunaux compétents du ressort du siège social de My Profolia.
            </p>
        </div>
    </section>
</template>
